import { __assign, __read, __rest } from "tslib";
import * as u from './urx';
import { findMaxKeyValue } from './AATree';
import { domIOSystem } from './domIOSystem';
import { offsetOf, originalIndexFromLocation, sizeSystem } from './sizeSystem';
import { loggerSystem } from './loggerSystem';
import { scrollToIndexSystem } from './scrollToIndexSystem';
import { listStateSystem } from './listStateSystem';
var defaultCalculateViewLocation = function (_a) {
    var itemTop = _a.itemTop, itemBottom = _a.itemBottom, viewportTop = _a.viewportTop, viewportBottom = _a.viewportBottom, _b = _a.locationParams, behavior = _b.behavior, align = _b.align, rest = __rest(_b, ["behavior", "align"]);
    if (itemTop < viewportTop) {
        return __assign(__assign({}, rest), { behavior: behavior, align: align !== null && align !== void 0 ? align : 'start' });
    }
    if (itemBottom > viewportBottom) {
        return __assign(__assign({}, rest), { behavior: behavior, align: align !== null && align !== void 0 ? align : 'end' });
    }
    return null;
};
export var scrollIntoViewSystem = u.system(function (_a) {
    var _b = __read(_a, 3), _c = _b[0], sizes = _c.sizes, totalCount = _c.totalCount, gap = _c.gap, _d = _b[1], scrollTop = _d.scrollTop, viewportHeight = _d.viewportHeight, headerHeight = _d.headerHeight, fixedHeaderHeight = _d.fixedHeaderHeight, fixedFooterHeight = _d.fixedFooterHeight, scrollingInProgress = _d.scrollingInProgress, scrollToIndex = _b[2].scrollToIndex;
    var scrollIntoView = u.stream();
    u.connect(u.pipe(scrollIntoView, u.withLatestFrom(sizes, viewportHeight, totalCount, headerHeight, fixedHeaderHeight, fixedFooterHeight, scrollTop), u.withLatestFrom(gap), u.map(function (_a) {
        var _b = __read(_a, 2), _c = __read(_b[0], 8), viewLocation = _c[0], sizes = _c[1], viewportHeight = _c[2], totalCount = _c[3], headerHeight = _c[4], fixedHeaderHeight = _c[5], fixedFooterHeight = _c[6], scrollTop = _c[7], gap = _b[1];
        var done = viewLocation.done, behavior = viewLocation.behavior, align = viewLocation.align, _d = viewLocation.calculateViewLocation, calculateViewLocation = _d === void 0 ? defaultCalculateViewLocation : _d, rest = __rest(viewLocation, ["done", "behavior", "align", "calculateViewLocation"]);
        var actualIndex = originalIndexFromLocation(viewLocation, sizes, totalCount - 1);
        var itemTop = offsetOf(actualIndex, sizes.offsetTree, gap) + headerHeight + fixedHeaderHeight;
        var itemBottom = itemTop + findMaxKeyValue(sizes.sizeTree, actualIndex)[1];
        var viewportTop = scrollTop + fixedHeaderHeight;
        var viewportBottom = scrollTop + viewportHeight - fixedFooterHeight;
        var location = calculateViewLocation({
            itemTop: itemTop,
            itemBottom: itemBottom,
            viewportTop: viewportTop,
            viewportBottom: viewportBottom,
            locationParams: __assign({ behavior: behavior, align: align }, rest),
        });
        if (location) {
            done &&
                u.handleNext(u.pipe(scrollingInProgress, u.filter(function (value) { return value === false; }), 
                // skips the initial publish of false, and the cleanup call.
                // but if scrollingInProgress is true, we skip the initial publish.
                u.skip(u.getValue(scrollingInProgress) ? 1 : 2)), done);
        }
        else {
            done && done();
        }
        return location;
    }), u.filter(function (value) { return value !== null; })), scrollToIndex);
    return {
        scrollIntoView: scrollIntoView,
    };
}, u.tup(sizeSystem, domIOSystem, scrollToIndexSystem, listStateSystem, loggerSystem), { singleton: true });
